import React, { FC } from 'react'

import { twMerge } from 'tailwind-merge'

import icons from '../../../js/icons'

type IconName = keyof typeof icons

export interface IconProps {
  name: string
  size?: number | string
  className?: string
  background?: string
  color?: string
  ariaLabel?: string
}

export const Icon: FC<IconProps> = ({
  name = '',
  size = 24,
  className = '',
  ariaLabel = '',
}) => {
  const IconComponent = icons[name as IconName]

  if (!IconComponent) {
    console.error(`Icon "${name}" not found in the icons mapping`)
    return null
  }

  const sizeAttributes = size !== 'auto' ? { width: size, height: size } : {}

  return (
    <IconComponent
      {...sizeAttributes}
      className={twMerge(className)}
      aria-label={ariaLabel || name}
    />
  )
}

export default Icon
